export default __webpack_public_path__ + "static/cd-finance-logo-8f51986c754894e4faf2b924b2d3e9bd.png";